import React from 'react'



const VideoComponent = ({src, title}) => {
    // return (
    //     <div className='video-container'>
           
    //         <iframe width="1190" height="670" src={src} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>


    //     </div>
    // )

    return ( 
    <div className='video-component-container'>
    
        <div className='video-container lateral-padding'>
        { title ? <h2 className='video-title'>{title}</h2> : ''}
         <video width="1190" controls>
                <source src={src} type="video/mp4"/>
                
            </video>

        </div>
   
    </div>
    
    )
}

export default VideoComponent



